import { render, staticRenderFns } from "./join-list.vue?vue&type=template&id=0f238a5c&scoped=true"
import script from "./join-list.vue?vue&type=script&lang=js"
export * from "./join-list.vue?vue&type=script&lang=js"
import style0 from "./join-list.vue?vue&type=style&index=0&id=0f238a5c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f238a5c",
  null
  
)

export default component.exports